import Breadcrumb from "../../Component/Breadcrumb";

function SpecialInstruction() {
  return (
    <>
      <Breadcrumb>Policies / Special Instruction To Students</Breadcrumb>

      <div className="innersec ">
        <div className="container">
          <div className="col-lg-12">
            <h1>Special Instruction To Students</h1>
          </div>
          <div className="recommendations-section">
            <div className="recommendations-card shadow-sm rounded-4 bg-white">
              <ol className="modern-list">
                <li>
                  In your dress and behaviour keep a sense of self-respect.
                  Right behaviour is the expression of fine character and a good
                  personality.
                </li>

                <li>Be simple in your ways and words.</li>

                <li>Avoid using indecent language.</li>

                <li>
                  <strong>COURTESY BEGETS COURTESY.</strong> Make use of words
                  like 'please, thank you, excuse me, sorry, May I' more often.
                  If you have to criticize, do not be destructive, but be
                  constructive.
                </li>

                <li>
                  In all your dealings with others be polite and obliging.
                  Always try to be a good companion to help others and hurt
                  nobody.
                </li>

                <li>
                  Respect your elders and teachers, whenever you meet them,
                  greet them with respect and love.
                </li>

                <li>
                  Be polite and helpful to the strangers coming to the school.
                </li>

                <li>
                  English is the medium of communication in the school premises.
                  Speak only in English during the school hours.
                </li>

                <li>Before and after every class stand up for prayer.</li>

                <li>
                  No exemption shall be given from school programs and
                  functions. Every student is expected to take part and
                  co-operate in the various school activities such as cultural
                  program, sports, games, drill etc.
                </li>

                <li>
                  Students are exhorted to make use of the Library and Reading
                  Room. Books and periodicals must be carefully handled and kept
                  neat and tidy.
                </li>

                <li>
                  No literature of any kind which is not directly connected with
                  the school curriculum should be brought to the school.
                </li>

                <li>
                  It is the duty of the pupils to see that the school premises
                  are kept clean & tidy.
                </li>

                <li>
                  Students should be friendly, courteous and co-operative
                  towards other students of the school, treating everyone with
                  respect and conducting themselves in a dignified manner.
                  Calling nick-names, spreading rumours etc. are strictly
                  forbidden.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default SpecialInstruction;
